module.exports = __webpack_public_path__ + "1f70167f765da52426fc174e563c349e.svg";